<template>
  <div>
    <PageHeaderBanner>
      <template #title>
        <span v-if="props.mode === DisplayModeCode.REGISTER">サプライヤ新規登録</span>
        <span v-if="props.mode === DisplayModeCode.CHANGE">サプライヤ情報変更</span>
      </template>
    </PageHeaderBanner>
    <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
    <q-form
      autofocus
      no-reset-focus
      greedy
      @submit="isDialogFlg = true"
      @reset="resetForm"
      @validation-error="resetErrors"
    >
      <div class="cmd00110-input-form q-gutter-y-xs">
        <div class="row">
          <div class="col">
            <label :class="props.mode === DisplayModeCode.REGISTER ? 'requier' : ''">
              サプライヤコード
            </label>
            <q-input
              v-if="props.mode === DisplayModeCode.REGISTER"
              ref="supplierCodeElem"
              v-model="inputData.supplier_code"
              outlined
              dense
              style="background: var(--q-white); width: 50%"
              class="input-area"
              maxlength="4"
              :rules="[
                (val) => isEmpty(val) || $t('validation.required'),
                (val) => isHalfAlphanumeric(val) || $t('validation.half_alphanumeric_only'),
              ]"
              lazy-rules
              @keydown.enter.prevent
            />
            <p v-if="props.mode === DisplayModeCode.CHANGE" class="q-ml-sm q-mt-sm">
              {{ inputData.supplier_code }}
            </p>
          </div>
          <div class="col flex justify-end">
            <q-toggle
              v-if="props.mode === DisplayModeCode.CHANGE"
              v-model="inputData.del_flg"
              label="無効にする"
              left-label
              size="lg"
            />
          </div>
        </div>
        <div class="col">
          <label class="requier">サプライヤ名</label>
          <q-input
            ref="supplierNameElem"
            v-model="inputData.supplier_name"
            outlined
            dense
            style="background: var(--q-white)"
            class="input-area left-input"
            maxlength="200"
            :rules="[(val) => isEmpty(val) || $t('validation.required')]"
            lazy-rules
            @keydown.enter.prevent
          />
        </div>
        <div class="col">
          <label class="requier">優先順位</label>
          <q-input
            v-model="inputData.priority"
            outlined
            dense
            style="background: var(--q-white); width: 25%"
            class="input-area"
            maxlength="4"
            mask="####"
            :rules="[
              (val) => !!val || $t('validation.required'),
              (val) =>
                (val > 0 && val <= 9999) ||
                $t('validation.between', { param1: '1', param2: '9999' }),
            ]"
            lazy-rules
            @keydown.enter.prevent
            @keypress.enter.prevent
          />
        </div>
        <div class="row q-gutter-x-md">
          <div class="col-3">
            <label>仕入先コード</label>
            <q-input
              v-model="inputData.real_supplier_code"
              outlined
              dense
              style="background: var(--q-white)"
              class="input-area"
              maxlength="7"
              :rules="[(val) => isHalfAlphanumeric(val) || $t('validation.half_alphanumeric_only')]"
              lazy-rules
              @keydown.enter.prevent
            />
          </div>
          <div class="col">
            <label>仕入先名</label>
            <q-input
              v-model="inputData.real_supplier_name"
              outlined
              dense
              style="background: var(--q-white)"
              class="input-area"
              maxlength="200"
              lazy-rules
              hint=""
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="col">
          <label>メーカーコード</label>
          <q-input
            v-model="inputData.maker_code"
            outlined
            dense
            style="background: var(--q-white); width: 25%"
            class="input-area"
            maxlength="9"
            mask="#########"
            lazy-rules
            @keydown.enter.prevent
            @keypress.enter.prevent
          />
        </div>
        <div v-if="props.mode === DisplayModeCode.CHANGE" class="row q-mt-md">
          <div class="col column">
            <label>登録者</label>
            <p class="q-mb-none q-ml-sm q-mt-sm">{{ inputData.create_user_name }}</p>
          </div>
          <div class="col column">
            <label>登録日時</label>
            <p class="q-mb-none q-ml-sm q-mt-sm">{{ inputData.create_timestamp }}</p>
          </div>
        </div>
        <FormFooterBanner style="position: inherit">
          <template #button-area>
            <div class="row">
              <q-btn
                color="grey-7"
                outline
                label="戻る"
                style="min-width: 120px; background: var(--q-white) !important"
                @click="router.replace({ name: 'supplier' })"
              />
              <div class="col q-gutter-x-xs flex justify-end">
                <q-btn
                  type="submit"
                  color="primary"
                  style="width: 150px"
                  :label="props.mode === DisplayModeCode.REGISTER ? '登録' : '変更'"
                />
                <q-btn
                  type="reset"
                  outline
                  style="
                    width: 150px;
                    background: var(--q-white) !important;
                    color: var(--q-delete);
                  "
                  :icon="props.mode === DisplayModeCode.REGISTER ? 'mdi-eraser' : 'cached'"
                  :label="props.mode === DisplayModeCode.REGISTER ? 'クリア' : 'リセット'"
                />
              </div>
            </div>
          </template>
        </FormFooterBanner>
      </div>
    </q-form>
    <AlertDialog
      :display="isDialogFlg"
      level="information"
      :title="props.mode === DisplayModeCode.REGISTER ? '登録確認' : '更新確認'"
      :text="
        props.mode === DisplayModeCode.REGISTER
          ? ['入力された内容で登録します。', 'よろしいですか？']
          : ['入力された内容で更新します。', 'よろしいですか？']
      "
      @confirm="submit()"
      @close="isDialogFlg = false"
    />
    <AlertDialog
      :display="isAlertFlg"
      level="information"
      confirmation
      :title="props.mode === DisplayModeCode.REGISTER ? '登録完了' : '更新完了'"
      :text="
        props.mode === DisplayModeCode.REGISTER
          ? ['登録が完了しました。']
          : ['更新が完了しました。']
      "
      @complete="router.replace({ name: 'supplier' })"
    />
  </div>
</template>
<script setup lang="ts">
import { Loading } from 'quasar';
import { reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty, isHalfAlphanumeric } from '../../common/utils/validateUtils';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';

interface Props {
  // 登録・変更モード
  mode: string;
  // サプライヤコード
  supplierCd?: string;
}

const router = useRouter();
const props = defineProps<Props>();

// サプライヤコードフォーカス用
const supplierCodeElem = ref<HTMLImageElement>();
// サプライヤ名フォーカス用
const supplierNameElem = ref<HTMLImageElement>();
// AlertDialog表示フラグ
const isDialogFlg = ref(false);
// AlertDialog表示フラグ
const isAlertFlg = ref(false);
// MessageChip表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');
// サプライヤコード
const supplierCode = ref(props.supplierCd ? props.supplierCd : '');

// 初期化用データ
const resetData = reactive({
  supplier_code: '',
  supplier_name: '',
  priority: '1',
  real_supplier_code: '',
  real_supplier_name: '',
  maker_code: '',
  del_flg: false,
  create_timestamp: '',
  create_user_name: '',
  update_user_name: '',
});

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * サプライヤ登録
 */
const registerSupplier = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 登録データ
  const formData = new FormData();
  formData.append('supplier_code', inputData.value.supplier_code);
  formData.append('supplier_name', inputData.value.supplier_name);
  formData.append('priority', inputData.value.priority);
  formData.append('real_supplier_code', inputData.value.real_supplier_code);
  formData.append('real_supplier_name', inputData.value.real_supplier_name);
  formData.append('maker_code', inputData.value.maker_code);

  // サプライヤ登録
  await axios
    .post('/cmd001101/register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR:
            case DetailResultStatusCode.INSERT_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * サプライヤ更新
 */
const updateSupplier = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  // 更新データ
  const formData = new FormData();
  formData.append('supplier_code', inputData.value.supplier_code);
  formData.append('supplier_name', inputData.value.supplier_name);
  formData.append('priority', inputData.value.priority);
  formData.append('real_supplier_code', inputData.value.real_supplier_code);
  formData.append('real_supplier_name', inputData.value.real_supplier_name);
  formData.append('maker_code', inputData.value.maker_code);
  formData.append('del_flg', inputData.value.del_flg ? '1' : '0');

  // サプライヤ更新
  await axios
    .post('/cmd001102/change', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR:
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * サプライヤ取得
 */
const getSupplier = async () => {
  // Loading Start
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('supplier_code', supplierCode.value);

  // サプライヤ取得
  await axios
    .post('/cmd001102/search', formData)
    .then((res) => {
      const { common, supplier } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 初期化用データ
          Object.assign(resetData, supplier);
          resetData.del_flg = supplier.del_flg !== '0';
          resetData.maker_code = supplier.maker_code ? supplier.maker_code : '';
          // フォームデータ
          inputData.value = { ...resetData };
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * フォーム初期化
 */
const resetForm = () => {
  inputData.value = { ...resetData };
  resetErrors();
  // 変更の場合
  if (props.mode === DisplayModeCode.CHANGE) {
    // サプライヤ名にフォーカス
    supplierNameElem.value?.focus();
  } else {
    supplierCodeElem.value?.focus();
  }
};

/**
 * submit
 */
const submit = () => {
  resetErrors();
  isDialogFlg.value = false;
  if (props.mode === DisplayModeCode.REGISTER) {
    registerSupplier();
  } else {
    updateSupplier();
  }
};

/**
 * 初期表示処理
 */
onMounted(() => {
  // propsが存在しない場合
  if (!props.mode) {
    // 前画面に遷移
    router.replace({ name: 'supplier' });
  }
  // 変更の場合
  if (props.mode === DisplayModeCode.CHANGE) {
    // サプライヤ名にフォーカス
    supplierNameElem.value?.focus();
    getSupplier();
  }
});
</script>
<style scoped>
.cmd00110-input-form {
  width: 70%;
  margin: 0 auto;
}
</style>
